







import BaseComponent from '@/components/base-component.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class SortTableColumnButton extends BaseComponent {
  @Prop()
  name: string;

  @Prop()
  pagination: PaginationSyncDTO;

  @Watch('pagination', { immediate: true })
  onChangePagination() {}

  onClick() {
    if (!this.pagination) {
      return;
    }

    if (this.name != this.pagination.sortBy) {
      this.pagination.descending = false;
      this.pagination.sortBy = this.name;
    } else {
      if (this.pagination.descending) {
        this.pagination.sortBy = null;
        this.pagination.descending = false;
      } else {
        this.pagination.descending = true;
      }
    }

    this.$emit('sort', this.pagination);
  }
}
